import React from 'react';
import { Modal } from 'react-bootstrap';

const AddTopicoModal = ({
	showModalAddTopico,
	setShowModalAddTopico,
	setReloadDataTopicos,
	reloadDataTopicos,
	setShowModalAddCurso,
	register,
	handleSubmit,
	errors,
	onSubmitAddTopico
}) => {
	const onSubmit = async (data) => {
		const result = await onSubmitAddTopico(data);
		if (result && result.success) {
			setReloadDataTopicos(!reloadDataTopicos);
			setShowModalAddTopico(false);
			// Opcionalmente abrir modal de curso após adicionar tópico
			if (setShowModalAddCurso) {
				setShowModalAddCurso(true);
			}
		}
	};

	return (
		<Modal
			size="lg"
			show={showModalAddTopico}
			onHide={() => setShowModalAddTopico(false)}
			backdrop="static"
		>
			<form onSubmit={handleSubmit(onSubmit)}>
				<Modal.Header closeButton>
					<span className="fw-semibold fs-5 text-primary">Adicionar Tópico/Tema</span>
				</Modal.Header>
				<Modal.Body className="bg-gray-100 p-4">
					<div className="container">
						<div className="row">
							<div className="col-md-12">
								<div className="body">
									<div className="d-flex">
										<div className="d-flex flex-column w-100">
											<div className="row mb-3">
												<div className="col-12">
													<div className="mb-3">
														<label className="form-label text-primary fw-medium">Nome</label>
														<input
															type="text"
															{...register("nome", { required: true })}
															placeholder="Nome do tópico"
															className="form-control border-new-light"
														/>
														{errors.nome && <span className='text-danger fs-7'>Nome do tópico é obrigatório.</span>}
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</Modal.Body>
				<Modal.Footer className="justify-content-end">
					<div className="d-flex justify-content-end">
						<button
							type="button"
							className="btn me-2"
							onClick={() => setShowModalAddTopico(false)}
						>
							Cancelar
						</button>
						<button type="submit" className="btn btn-primary">Salvar</button>
					</div>
				</Modal.Footer>
			</form>
		</Modal>
	);
};

export default AddTopicoModal; 